// Single source for the Effy Order page FAQ. The visible FAQ section and the
// FAQPage JSON-LD are both built from this list so they always match.
export const EFFY_ORDER_FAQS = [
  {
    question: 'What is an order management tool?',
    answer: 'An order management tool helps businesses create, track, and fulfill customer orders from start to delivery. Effy Orders lets you manage orders, auto-update inventory, generate GST invoices, and notify customers — all in one platform.',
  },
  {
    question: 'Does EffyVenture offer a free trial for order and inventory management?',
    answer: 'Yes. Effy Orders plans start at ₹199/month and come with a 30-day free trial, so you can try order tracking, inventory management, GST invoices, and reports before you pay.',
  },
  {
    question: 'Does EffyVenture support GST invoice generation?',
    answer: 'Yes. Effy Orders automatically generates GST-compliant invoices with CGST, SGST, and IGST breakdowns. You can print or share invoices and delivery challans directly from the platform.',
  },
  {
    question: 'Can I manage inventory with EffyVenture?',
    answer: 'Yes. Effy Orders includes full inventory management — track stock levels in real time, get low stock alerts before you run out, bulk upload products via Excel, generate barcodes, and auto-sync inventory whenever an order is placed.',
  },
  {
    question: 'Does EffyVenture support bulk order uploads?',
    answer: 'Yes. You can upload hundreds of orders at once using an Excel file with our bulk upload feature — ideal for businesses processing large order volumes daily.',
  },
];
